export const riskCategoryMeta = {
  AI: { label: 'AI 使用', color: 'blue' },
  ACCOUNT: { label: '账号设备', color: 'cyan' },
  INVITE: { label: '邀请', color: 'purple' },
  ORDER_REBATE: { label: '订单返利', color: 'gold' },
  WITHDRAWAL: { label: '提现', color: 'volcano' },
  TAOBAO_BINDING: { label: '淘宝绑定', color: 'magenta' },
};

export const riskSeverityMeta = {
  MEDIUM: { label: '中风险', color: 'orange' },
  HIGH: { label: '高风险', color: 'red' },
};

export const riskStatusMeta = {
  OPEN: { label: '待处理', color: 'processing' },
  CONFIRMED: { label: '已确认', color: 'error' },
  IGNORED: { label: '已忽略', color: 'default' },
};

export const metricUnitLabel = {
  COUNT: '次',
  WINDOW_COUNT: '次',
  USER_COUNT: '人',
  DEVICE_COUNT: '个设备',
  CNY: '元',
  RATIO: '比例',
  BOOLEAN: '命中',
};

export const formatMetric = (value, unit) => {
  if (value === null || value === undefined) return '-';
  if (unit === 'RATIO') return `${(Number(value) * 100).toFixed(1)}%`;
  if (unit === 'CNY') return `¥${Number(value).toFixed(2)}`;
  if (unit === 'BOOLEAN') return Number(value) > 0 ? '是' : '否';
  return `${Number(value).toLocaleString()} ${metricUnitLabel[unit] || unit || ''}`.trim();
};

export const formatWindow = (minutes) => {
  const value = Number(minutes || 0);
  if (value % 1440 === 0) return `${value / 1440} 天`;
  if (value % 60 === 0) return `${value / 60} 小时`;
  return `${value} 分钟`;
};

export const riskRuleValidationError = (values) => {
  const windowMinutes = Number(values?.windowMinutes);
  const mediumThreshold = Number(values?.mediumThreshold);
  const highThreshold = Number(values?.highThreshold);
  const minimumSampleSize = Number(values?.minimumSampleSize);
  if (!Number.isFinite(windowMinutes) || windowMinutes < 1 || windowMinutes > 525600) {
    return '统计窗口必须在 1 分钟到 365 天之间';
  }
  if (!Number.isFinite(mediumThreshold) || mediumThreshold < 0) {
    return '中风险阈值不能小于 0';
  }
  if (!Number.isFinite(highThreshold) || highThreshold < mediumThreshold) {
    return '高风险阈值不能低于中风险阈值';
  }
  if (!Number.isInteger(minimumSampleSize) || minimumSampleSize < 1) {
    return '最小样本数必须是正整数';
  }
  return null;
};
